import AxiosService from '@/services/AxiosServices'

export default {
  /**
   * Get list of Papers
   *
   * @param perPage => limit
   * @param page => item by page
   * @param order => obj with index and ASC or DESC
   * @param search => research
   * @returns {*}
   */
  getPapers(perPage, page, order, search) {
    let url = 'admin/papers'
    if(perPage)
      url += '?_limit=' + perPage + '&_page=' + page
    if(order !== null)
      url += '&_index=' + order.index + '&_order=' + order.order
    if(search !== null)
      url += '&_search=' + search

    return AxiosService.callApi().get(url)
  },
  /**
   * Get Paper by id
   *
   * @param id
   * @returns {*}
   */
  getPaper(id) {
    return AxiosService.callApi().get('/admin/papers/' + id)
  },
  /**
   * Create Paper
   *
   * @param data
   * @returns {*}
   */
  create(data) {
    return AxiosService.callApi().post('/admin/papers', data)
  },
  /**
   * Edit Paper
   *
   * @param id
   * @param data
   * @returns {*}
   */
  edit(id, data) {
    return AxiosService.callApi().put('/admin/papers/' + id, data)
  },
  /**
   * Delete Paper
   *
   * @param id
   * @returns {*}
   */
  delete(id) {
    return AxiosService.callApi().delete('/admin/papers/' + id)
  }
}
